var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-lg btn-primary w-100",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.openPayBills}},[_vm._v(" Pay "+_vm._s(_vm.total)+" ")]),_c('PayBillModal',{attrs:{"total":_vm.total,"id":'paybill',"closeModal":_vm.closeModal,"bill":_vm.bill,"reset":_vm.reset,"setApiResponse":_vm.setApiResponse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }